Shopify.customCart = Shopify.customCart || {};
Shopify.customCart.formatMoney = function(value) {
  return Intl.NumberFormat('en-US',{style:'currency',currency:'USD',maximumFractionDigits:2}).format(value);
}

function openCartDrawer() {
  setTimeout(function(){
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
    document.querySelector("html").classList.add("cart-drawer--active");
    document.querySelector("body").classList.add("cart-drawer--active");
    if(document.querySelector(".rebuy-cart")){
      document.querySelector(".rebuy-cart").remove();
    }
  },400)
}

function closeCartDrawer() {
  document
    .querySelector(".cart-drawer")
    .classList.remove("cart-drawer--active");

  document.querySelector("html").classList.remove("cart-drawer--active");
  document.querySelector("body").classList.remove("cart-drawer--active");
}

function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    if(count == '0'){
      document.querySelector(".cart-count-bubble").classList.add("hidden");
    }else{
      document.querySelector(".cart-count-bubble").classList.remove("hidden");
    }
    el.textContent = count;
  });
}

async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
  tieredDiscount();
  addDiscountCodeListeners();
  updateCartDiscounts();
}

async function errorUpdateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;

  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;

  addCartDrawerListeners();
  errorTieredDiscount();
  addDiscountCodeListeners();
  updateCartDiscounts();
}

function addCartDrawerListeners() {

  // Remove handling Shipping and Tax products here
  const handling = document.querySelector(".handling-product")?.innerHTML;
  if(handling == 'true'){
    const cartdata = fetch("/cart/update.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates: { [43033812107448] : 0, [43032880480440] : 0, [43033812762808] : 0 } }),
    });
    location.reload();
  }
  // Update quantities
  document
    .querySelectorAll(".cart-drawer-quantity-selector button")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        button.classList.add("loader-icon");
        // Get line item key
        const rootItem =
          button.parentElement.parentElement.parentElement.parentElement;

        const key = rootItem.getAttribute("data-line-item-key");

        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains(
          "cart-drawer-quantity-selector-plus"
        );
        const newQuantity = isUp ? currentQuantity : currentQuantity;

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();

      });
    });

  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });

  // remove icon update
  if(document.querySelector(".cart-remove-button")){
    document
      .querySelectorAll(".cart-remove-button")
      .forEach((remove_button) => {
      remove_button.addEventListener("click", async (e) => {
      e.preventDefault();
      const remove_key = remove_button.getAttribute("data-product-key");

        // Ajax update
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [remove_key]: 0 } }),
        });
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
    });
  });
  }

  document
    .querySelectorAll(".cart-drawer-header-right-close, .cart-drawer")
    .forEach((el) => {
      el.addEventListener("click", () => {

        closeCartDrawer();
      });
    });

}

addCartDrawerListeners();

document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    // different recipients logic
    const qty = document.querySelector('input[name="quantity"]')?.value;
    const checkboxcheck = document.querySelector('#splitQtyCheck')?.checked;
    const customiseProduct = document.querySelector('.cpb-radio-button-text')?.innerHTML;
    if(customiseProduct == undefined){
    if (qty > 1 && checkboxcheck) {
      const id = document.querySelector('input[name="id"]')?.value;
      const _image = document.querySelector('input[name="properties[_image]"]')?.value;
      const Message = document.querySelector('textarea[name="properties[Message]"]')?.value;``
      const To = document.querySelector('input[name="properties[To]"]')?.value;
      const From = document.querySelector('input[name="properties[From]"]')?.value;
      var cartItem = {
        'items': []
      };
      for (var i = 0; i < qty; i++) {
        var currentItem = {
          'id': id,
          'quantity': 1,
          'properties': {
            'Message': Message,
            'To': To,
            'From': From,
            '_image': _image,
            '_rand': Math.floor(
              (Math.random() * 10000) + 1
            )
          }
        }
        cartItem["items"].push(currentItem);
      }
      // Submit form with ajax for different line item
      await fetch("/cart/add", {
        method: "post",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartItem)
      });
    }else{
      const id = document.querySelector('input[name="id"]')?.value;
      const _image = document.querySelector('input[name="properties[_image]"]')?.value;
      const Message = document.querySelector('textarea[name="properties[Message]"]')?.value;``
      const To = document.querySelector('input[name="properties[To]"]')?.value;
      const From = document.querySelector('input[name="properties[From]"]')?.value;
      var cartItem = {
        'items': []
      };
      var currentItem = {
          'id': id,
          'quantity': qty,
          'properties': {
            'Message': Message,
            'To': To,
            'From': From,
            '_image': _image
          }
        }
      cartItem["items"].push(currentItem);

      //Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(cartItem)
      });
    }
  }

    // Get cart count
    const res = await fetch("/cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);

    // Update cart
    await updateCartDrawer();

    // Open cart drawer
    openCartDrawer();
  });
});

document.querySelectorAll('a[href="/cart"]').forEach((a) => {
  if (a.closest('#ajax-cart')) return; // Don't override the cart drawer cart link
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});

function tieredDiscount() {
  var baseTieredAmount = Shopify.tieredDiscount.baseTieredAmount*100;
  var cartTotalPrice = document.querySelector('.cart-total-price')?.innerHTML;
  const currentURL = window.location.search;
  const urlParams = new URLSearchParams(currentURL);
  const discount = urlParams.get('coupon');
  const open_to_all_users = document.querySelector('.open-to-all-users')?.innerHTML;
  const coupon_code = document.querySelector('.tiered-discount-code')?.innerHTML;
  const tiered_coupon_code = document.querySelector('.tiered-coupon-code')?.innerHTML;
  const applied_coupon_code = document.querySelector('.cart__discount-tag-text')?.innerHTML;

  if(open_to_all_users == 'true'){
    document.querySelector("#ajax-cart-discount-input").value = coupon_code;
    document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
    fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':coupon_code}})})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
          return calculateCartDiscounts(data, coupon_code);
        });
  }else{
    //document.querySelector(".flyout-progress-container")?.classList.add("hidden");
  }

  if(urlParams.has('coupon')){
    if(baseTieredAmount <= cartTotalPrice){
      document.querySelector("#ajax-cart-discount-input").value = discount;
      document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
      openCartDrawer();
    }else{
      if(document.querySelector("#ajax-cart-discount-input")?.value != undefined){
        document.querySelector("#ajax-cart-discount-input").value = '';
      }
     //document.querySelector(".flyout-progress-container")?.classList.add("hidden");
    }
    fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'coupon_code':discount,'discount_code':discount}})})
        .then((response) => {
          return response.json();
      })
  }

  if(tiered_coupon_code != ''){
    if(tiered_coupon_code != undefined){
      document.querySelector("#ajax-cart-discount-input").value = tiered_coupon_code;
    }
    document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
    fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':tiered_coupon_code}})})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
          if(tiered_coupon_code != undefined){
            //return calculateCartDiscounts(data, tiered_coupon_code);
          }
        });
  }else{
    //document.querySelector(".flyout-progress-container")?.classList.add("hidden");
  }

  if(applied_coupon_code != ''){
    document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
  }
}

function errorTieredDiscount() {
  const open_to_all_users = document.querySelector('.open-to-all-users')?.innerHTML;

  if(open_to_all_users == 'true'){
    document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
  }else{
    //document.querySelector(".flyout-progress-container")?.classList.add("hidden");
  }


}

function addDiscountCodeListeners() {

  // Add discount code
  document.querySelectorAll('.cart__discount-apply-button').forEach((el) => {
    el.addEventListener("click", async (e) => {
      e.preventDefault();
      let code = el.closest('form').querySelector('.cart__discount-input')?.value;
      if (!code) {
        setCouponMessage("Please specify a coupon code");
        return;
      }
      // Add/update the discount code in cart attributes
      fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':code,'coupon_code':code}})})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          document.querySelector(".flyout-progress-container")?.classList.remove("hidden");
          return calculateCartDiscounts(data, code);
        });
    });
  });

  // Remove discount code
  document.querySelectorAll('.cart__discount-tag-remove').forEach((el) => {
    el.addEventListener("click", async (e) => {
      e.preventDefault();
      await fetch(window.Shopify.routes.root + `discount/0`,{method: 'GET',headers: {'Content-Type':'application/json'}});
      // Remove the discount code from cart attributes
      await fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':null,'coupon_code':null}})});
      // Update the cart drawer without the metafield
      const open_to_all_users = document.querySelector('.open-to-all-users')?.innerHTML;
      if(open_to_all_users == 'true'){
        await updateCartDrawer();
      }else{
        await errorUpdateCartDrawer();
      }
    });
  });
}
tieredDiscount();
addDiscountCodeListeners();

async function updateCartDiscounts() {
  const code = document.querySelector('.cart__discount-input')?.value;
  if (code) {
    let response = await fetch('/cart.js');
    let data = await response.json();
    await calculateCartDiscounts(data, code);
  } else {
    // Reset discounts
  }
}

async function calculateCartDiscounts(data, code) {
  disableDiscountFields();
  if (data.items) {
    const payload = {
      cart: data,
      code: code
    };
    const response = await fetch("/a/shipping/coupon", {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json"
      },
      referrerPolicy: "no-referrer",
      body: JSON.stringify(payload)
    });
    const responseData = await response.json();
    let isValid = false;
    let isFreeShippingValid = false;
    if (typeof responseData.discountCodes === "undefined") {
      await updateCartDrawer();
      setCouponMessage("An error occurred applying the coupon code");
    } else {
      responseData.discountCodes.forEach((discountCode) => {
        if (discountCode.code == code) {
          isValid = discountCode.applicable;
        }
      });
      let cart_items = responseData.items;
      let cart_discount_total = 0;
      let cartTotalPrice = parseInt(document.querySelector('.cart-total-price')?.innerHTML);
      let i;
      for(i = 0; i < cart_items.length; i++){
        if( cart_items[i].subtotal > cart_items[i].total){
          cart_discount_total += cart_items[i].subtotal;
        }
      }
      cart_discount_total = cart_discount_total.toFixed(2)*100;
      if (responseData.freeShippingData && responseData.freeShippingData.codeApplies) {
        if (responseData.total > responseData.freeShippingData.minimumRequirement) {
          isFreeShippingValid = true;
          //TODO: Set free shipping applied message
        }
      }
      if (!isValid && !isFreeShippingValid) {
        await fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discount_code':null,'discounted_cart_total':null}})});
        await errorUpdateCartDrawer();
        const theme_coupon_code = document.querySelector('.tiered-discount-code')?.innerHTML;
        document.querySelector("#progress")?.classList.add("zero-width");
        if(theme_coupon_code !=  code){
          setCouponMessage("Please note: discount codes cannot be applied to items on sale.");
        }
      } else {
        document.querySelector("#progress")?.classList.remove("zero-width");
        if (responseData.lineDiscount > 0) {
          //TODO: Apply line discounts
        } else {
          document.querySelectorAll('#ajax-cart .cart-item').forEach((row) => row.dataset.discount = 0);
          //TODO: reset cart page discounts
        }

        if(cart_discount_total > 0 && cartTotalPrice >= cart_discount_total){
          await fetch('/cart/update.js',{method: 'POST',headers: {'Content-Type':'application/json'},body:JSON.stringify({attributes:{'discounted_cart_total':cart_discount_total}})});
           const res = await fetch("/?section_id=cart-drawer");
           const text = await res.text();
           const html = document.createElement("div");
           html.innerHTML = text;

          const newBox = html.querySelector(".cart-drawer").innerHTML;
          document.querySelector(".cart-drawer").innerHTML = newBox;

          addCartDrawerListeners();
          tieredDiscount();
          addDiscountCodeListeners();
        }
        document.querySelectorAll('.cart__discount-amount').forEach((el) => {
          el.dataset.totalDiscount = Math.round(responseData.totalDiscount*100);
          el.querySelector('.amount').innerHTML = "- " + Shopify.customCart.formatMoney(responseData.totalDiscount);
        });
        document.querySelectorAll('.totals__subtotal-value').forEach((el) => {

          const newFormattedDiscount = Shopify.customCart.formatMoney(responseData.totalDiscount);
          const newFormattedTotal = Shopify.customCart.formatMoney(responseData.total);
          const newFormattedCompare = Shopify.customCart.formatMoney(responseData.subtotal);
          el.innerHTML = `<span data-cart-subtotal="`+(responseData.subtotal*100)+`">`+newFormattedTotal+`</span> <span class="old-price">`+newFormattedCompare+`</span>`;
        })
        document.querySelectorAll('.cart__discount-form').forEach((el) => el.classList.remove('show'));
        document.querySelectorAll('.cart__discount-tag').forEach((el) => el.classList.add('show'));
        document.querySelectorAll('.cart__discount-amount').forEach((el) => el.classList.add('show'));
        document.querySelectorAll('.cart__discount-tag-text').forEach((el) => el.innerText = code);
        clearCouponMessage();
      }
    }
  }
  enableDiscountFields();
}

async function disableDiscountFields() {
  document.querySelectorAll('.cart__discount-apply-button,.cart__discount-input').forEach((el) => el.disabled = true);
}
async function enableDiscountFields() {
  document.querySelectorAll('.cart__discount-apply-button,.cart__discount-input').forEach((el) => el.disabled = false);
}
function setCouponMessage(message) {
  document.querySelectorAll('.cart__discount-error').forEach((el) => {
    el.innerHTML = message;
    el.classList.add('show');
  })
  //return false;
}
function clearCouponMessage() {
  document.querySelectorAll('.cart__discount-error').forEach((el) => {
    el.innerHTML = '';
    el.classList.remove('show');
  })
}
updateCartDiscounts();
